<template>
  <div class="notifications">
    <div style="position: absolute" class="center-alert">
      <Notification
        v-for="notification in notifications"
        :key="notification.text"
        :notification="notification"
        transition="fade"
      />
    </div>
  </div>
</template>

<script>
import Notification from "./Notification";
export default {
  name: "Notifications",
  components: {
    Notification,
  },
  data() {
    return {
      notifications: this.$store.state.notifications,
    };
  },
  methods: {
    removeNotification: function (notification) {
      this.$store.commit("removeNotification", notification);
    },
  },
};
</script>
